export async function validatorImage(rule, value) {
    const imageUrlRegex = /\.(jpeg|jpg|gif|png)$/i;
    if (value === "") {
        return Promise.resolve()
    }
    const isValidImageUrl = imageUrlRegex.test(value);
    const errors = []
    if (!isValidImageUrl) {
        errors.push(new Error("Не является прямой ссылкой на изображение"))
    }
    if (errors.length) {
        return Promise.reject(errors)
    } 
    else {
        return Promise.resolve()
    }
}